var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.content,
    placement: 'top',
    offset: 8,
    classes: 'tooltip--new'
  }),expression:"{\n    content,\n    placement: 'top',\n    offset: 8,\n    classes: 'tooltip--new'\n  }"}],staticClass:"automation-info-tooltip",attrs:{"type":"button","aria-label":_vm.ariaLabel || _vm.content},on:{"click":function($event){$event.stopPropagation();}}},[_c('img',{attrs:{"src":require("@/assets/img/info-text-panel-icon.svg"),"alt":"","aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }